export const breadCrumbLaraThemeConfig = {
  padding: "0",
  background: "transparent",
  gap: "var(--spacing-8)",
};
